<template>
  <div class="baiduQueue">
      <div class="box">
          <div class="b1"><div class="b11">{{item.orgName}}</div></div>
          <div class="b2">
              <div>
                  <img src="/static/index/index9.png" alt="">
                  <div>{{item.province}}{{item.city}}{{item.area}}</div>
              </div>
              <div>
                  <img src="/static/index/index10.png" alt="">
                  <div>咨询电话：{{item.telephone}}</div>
              </div>
          </div>
          <div class="title">介绍</div>
          <div class="remark">{{item.introduce}}</div>
          <div class="title">培训风采</div>
          <div class="img">
              <img v-for="(items,index) in item.imageUrl.split(',')" :key="index" :src="items"  alt="">
          </div>
          <div class="title">课程</div>
          <div class="img">
               <img v-for="(items,index) in item.description.split(',')" :key="index" :src="items" alt="">
          </div>
      </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";
export default {
  title: "课程列表",
  data() {
    return {
      item:{}
    };
  },
  computed: {},
  components: {},
  methods: {
    getData() {
      console.log(this.$route)
        this.$axios.post('/get_orga_detail', this.$qs.stringify({oid:this.$route.query.id})).then(res => {
            this.item=res.data.data
        })
    },
  },

  mounted() {
    this.getData();  
  },
};
</script>  
<style lang="scss" scoped>
.baiduQueue{
  width: 100%;
  // height: 100%;
  // overflow-y: auto;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  padding-top: 50px;
  padding-bottom: 92px;
  .box{
      width: 1132px;
      padding: 0 34px;
      margin: 0 auto;
    .b1{
        display: flex;
        align-items: center;
        justify-content: center;
        .b11{
            height: 64px;
        display:inline-block;
        padding: 0 53px;
        line-height: 64px;
        background: #333333;
        font-size: 40px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #FFFFFF;
        margin: 0 auto 18px;
        }
    }
    .b2{
        display: flex;
        align-items: center;
        justify-content: center;
        &>div{
            display: flex;
            align-items: center;
            margin-right: 69px;
            img{
                width: 18px;
                height: 18px;
                margin-right: 3px;
            }
            div{
                font-size: 24px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #999999;
            }
        }
    }
    .title{
        font-size: 24px;
font-family: SourceHanSansCN-Bold, SourceHanSansCN;
font-weight: bold;
color: #333333;
margin-bottom: 20px;
    }
    .remark{
        font-size: 20px;
font-family: SourceHanSansCN-Regular, SourceHanSansCN;
font-weight: 400;
color: #333333;
margin-bottom: 50px;
    }
    .img{
        margin-bottom: 50px;
        img{
            width: 100%;
            margin-bottom: 20px;
        }
    }
  }
}
</style>  


// WEBPACK FOOTER //
// src/pages/collegeDetail/index.vue